export default __webpack_public_path__ + "static/Software_image-85a74821c0ca7ce673f84831c1020408.svg";